// extracted by mini-css-extract-plugin
module.exports = {"container":"Scene_container__3y4cE","canvas":"Scene_canvas__3CWV-","title":"Scene_title__z7e7t"};